import { Outlet, createRootRoute } from "@tanstack/react-router";

import { AdminAppProviders } from "@app/providers/AdminAppProviders";

export const rootRoute = createRootRoute({
  component: () => (
    <AdminAppProviders>
      <Outlet />
    </AdminAppProviders>
  ),
});
